export default {
	birthday: "Geburtsdatum",
	insuredNumber: "Funk-Versicherungsnummer",
} as const;
